import React from 'react';

import Icon from '../Icon/Icon';

const UserIcon = (props) => {
    return (
        <Icon width='24' height='24' fill='none' {...props}>
            <circle cx='12' cy='12' r='12' fill='#00D1D2' />
            <g clipPath='url(#clip0_9705_25346)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.6673 13.6667C15.0815 13.6667 15.4565 13.8345 15.728 14.106C15.9994 14.3774 16.1673 14.7524 16.1673 15.1667V16.7917C16.1673 17.0218 16.074 17.2301 15.9232 17.3809C15.7724 17.5317 15.5641 17.625 15.334 17.625H8.66732C8.4372 17.625 8.22887 17.5317 8.07806 17.3809C7.92726 17.2301 7.83398 17.0218 7.83398 16.7917V15.1667C7.83398 14.7524 8.00188 14.3774 8.27332 14.106C8.54477 13.8345 8.91977 13.6667 9.33398 13.6667H14.6673Z'
                    stroke='#393E44'
                    strokeWidth='1.5'
                />
                <path
                    d='M12.0007 11.8333C13.4734 11.8333 14.6673 10.6394 14.6673 9.16667C14.6673 7.69391 13.4734 6.5 12.0007 6.5C10.5279 6.5 9.33398 7.69391 9.33398 9.16667C9.33398 10.6394 10.5279 11.8333 12.0007 11.8333Z'
                    stroke='#393E44'
                    strokeWidth='1.5'
                />
            </g>
            <defs>
                <clipPath id='clip0_9705_25346'>
                    <rect width='16' height='16' fill='white' transform='translate(4 4)' />
                </clipPath>
            </defs>
        </Icon>
    );
};

export default UserIcon;
